module.exports = __webpack_public_path__ + "img/clock-gray.ff24e09d.svg";